import React, { createElement, forwardRef, useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { getFieldError, spacedNum } from "../../CommonHelper"

const parseInputDate = (val: string | undefined): Date | null => {
  if (!val || val.length < 10) return null
  const d = new Date(val)
  return isNaN(d.getTime()) ? null : d
}

const formatToIso = (d: Date | null): string => {
  if (!d) return ""
  return d.toISOString().split("T")[0]
}

const DateInput = forwardRef<HTMLInputElement, React.ComponentProps<"input">>((props, ref) => (
  <input {...props} ref={ref} className="input-form-date" readOnly />
))
DateInput.displayName = "DateInput"

export const CommonInput: React.FC<{
  typeName: string
  label?: string
  placeholder: string
  name: string
  value: string | undefined
  errorModel?: IErrorModel
  _callback: (value: string | undefined) => void
  disabled?: boolean
  readonly?: boolean
  customError?: string
  maxLength?: number
}> = ({
  typeName,
  label,
  placeholder,
  name,
  value,
  errorModel,
  _callback,
  disabled,
  readonly,
  customError,
  maxLength
}) => {
  const [localValue, setLocalValue] = useState<string | undefined>(value)
  const MAX_DATE = new Date()

  useEffect(() => {
    setLocalValue(typeName === "number" ? (value ? spacedNum(value) : undefined) : value)
  }, [value])

  useEffect(() => {
    _callback(localValue)
  }, [localValue])

  const changeValue = (val: string | undefined) => {
    if (typeName === "number") {
      if (!val || val.length === 0) {
        setLocalValue("")
        return
      }
      val = val.replace(/,/g, ".")
      val = val.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1")
      setLocalValue(spacedNum(val))
    } else {
      setLocalValue(val)
    }
  }

  // const checkDateString = (val: string | undefined) => {
  //   if (val && new Date(val) > MAX_DATE && val.length >= 10) {
  //     setLocalValue(dateToInputString(MAX_DATE))
  //   } else if (val && new Date(val) < MIN_DATE && val.length >= 10) {
  //     setLocalValue(dateToInputString(MIN_DATE))
  //   } else {
  //     setLocalValue(val)
  //   }
  // }

  return (
    <fieldset
      translate="no"
      style={{
        ...(disabled ? { pointerEvents: "none", opacity: 0.7 } : {}),
        ...(readonly ? { pointerEvents: "none" } : {})
      }}
    >
      {label && <legend>{label}</legend>}
      {typeName === "date" ? (
        <DatePicker
          selected={parseInputDate(localValue)}
          onChange={(date: Date | null) => {
            setLocalValue(formatToIso(date))
          }}
          minDate={new Date("2023-12-31")}
          maxDate={MAX_DATE}
          dateFormat="dd.MM.yyyy"
          placeholderText={placeholder}
          customInput={createElement(DateInput)}
          wrapperClassName="width-full"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      ) : (
        <input
          type={typeName === "number" ? "text" : typeName}
          className="input-form"
          placeholder={placeholder}
          onChange={e => changeValue(e.target.value)}
          value={localValue}
          maxLength={maxLength}
        />
      )}
      {getFieldError(errorModel, name) ? <p className="error-form">{getFieldError(errorModel, name)}</p> : <></>}
      {customError ? <p className="error-form">{customError}</p> : <></>}
    </fieldset>
  )
}
